<template>
  <div id="app">
    <router-view></router-view>
    <AsideFixed />
  </div>
</template>

<script>
import AsideFixed from '@/components/common/AsideFixed.vue'

export default {
  name: 'App',
  components: {
    AsideFixed
  },
  created() {
    // order_components store
    this.$store.dispatch('orderUser/getUserInfo')
    // 监听浏览器标签页切换
    document.addEventListener('visibilitychange', this.handleVisibilityChange, false)
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange, false)
  },
  methods: {
    // 浏览器标签页切换
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        this.$store.dispatch('orderUser/getUserInfo')
      }
    }
  }
}
</script>

<style>
</style>
